import {areBrandsInEmptyState} from "@Libraries/brands-library";
import {useAppSelector} from "@/hooks";

export const useDoesUserHaveBrandKits = (): boolean => {
    return useAppSelector(state => {
        return !areBrandsInEmptyState(state.brands.brands, state.brands.brandsLoadingState);
    })
}